import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sandian",
  "use": "icon-sandian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sandian\">\n    <path d=\"M0 0h1024v1024H0z\" opacity=\".01\" p-id=\"4782\" />\n    <path d=\"M238.933333 512a68.266667 68.266667 0 1 0-136.533333 0 68.266667 68.266667 0 0 0 136.533333 0z m273.066667-68.266667a68.266667 68.266667 0 1 1 0 136.533334 68.266667 68.266667 0 0 1 0-136.533334z m341.333333 0a68.266667 68.266667 0 1 1 0 136.533334 68.266667 68.266667 0 0 1 0-136.533334z\" p-id=\"4783\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol